<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { usePatientStore } from './stores/patient'
import { useScreenStore } from './stores/screen'
import { usePwa } from '@/composables/usePwa'

const patientStore = usePatientStore()
const screenStore = useScreenStore()
const pwa = usePwa()

function handleBeforeInstall(e: Event) {
    try {
        ; (e as any).preventDefault()
    } catch { }
    pwa.setDeferredPrompt(e)
}

function handleAppInstalled() {
    pwa.handleAppInstalled()
}

onMounted(async () => {
    // Load the patient data if they are authed
    if (patientStore.isAuthenticated) {
        try {
            await patientStore.ensurePatient()
        } catch (error) {
            console.error('Failed to load patient')
        }
    }

    // Event listeners for updating screen size variable
    screenStore.updateLayoutFlag()
    window.addEventListener('resize', screenStore.updateLayoutFlag)
    window.addEventListener('orientationchange', screenStore.updateLayoutFlag)

    // Capture PWA install availability early (app-level)
    window.addEventListener('beforeinstallprompt', handleBeforeInstall as EventListener)
    window.addEventListener('appinstalled', handleAppInstalled as EventListener)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', screenStore.updateLayoutFlag)
    window.removeEventListener('orientationchange', screenStore.updateLayoutFlag)
    window.removeEventListener('beforeinstallprompt', handleBeforeInstall as EventListener)
    window.removeEventListener('appinstalled', handleAppInstalled as EventListener)
})
</script>

<template>
    <router-view />
</template>

<style lang="css">
@import './styles/main.css';
</style>